// Mesma tela de conta do agendamento avulso, sem agendamento único por trás
// (pedido de recorrência/assinatura): telefone guardado + e-mail/senha opcionais.
export { default } from './[appointmentId]/conta';
